<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'orgBuild'
}
</script>

<style>

</style>
